var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel", attrs: { id: "rust-benfits" } }, [
    _c("div", { staticClass: "rust-icon" }),
    _vm._v(" "),
    _c("p", { staticClass: "order-benefits" }, [
      _c("span", { domProps: { innerHTML: _vm._s(_vm.getTitle()) } }),
      _vm._v(" "),
      _c("b", { attrs: { id: "gamecloud-slots" } }, [
        _vm._v(_vm._s(_vm.slots)),
      ]),
      _vm._v(
        "\n    " +
          _vm._s(_vm.$t("checkout:stepone.game_checkout_info.rust.slot_info")) +
          "\n    "
      ),
      _c("b", { attrs: { id: "actual-slots" } }, [
        _vm._v(_vm._s(_vm.getSlotsPerRustServer())),
      ]),
      _vm._v(" " + _vm._s(_vm.getServerSlotInfo()) + "\n  "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }